import { useEffect } from "react";
import { useNavigate } from "react-router";

export function VerifiedPage() {
  const nav = useNavigate();
  useEffect(() => {
    document.title = "E-mail bevestigd | Carmen";
  }, []);

  return (
    <div className="relative flex min-h-screen flex-col overflow-hidden bg-slate-50">
      <div className="flex flex-1 items-center justify-center px-5 py-12 sm:px-8">
        <div className="w-full max-w-lg animate-fade-in-up">
          <div className="glass-card rounded-3xl border border-slate-200 p-8 text-center shadow-sm sm:p-10">
            <div className="mb-8">
              <img src="/logo.svg" alt="Carmen" className="mx-auto h-10" />
            </div>

            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full border-2 border-green-200 bg-green-50">
              <svg
                className="h-8 w-8 text-green-600"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <path d="M9 12l2 2 4-4" />
                <circle cx="12" cy="12" r="10" />
              </svg>
            </div>

            <h1 className="mb-3 text-2xl font-bold text-slate-900">E-mailadres bevestigd!</h1>
            <p className="mb-6 text-[15px] leading-relaxed text-slate-600">
              Uw e-mailadres is succesvol geverifieerd. Bedankt!
            </p>

            <div className="mb-6 rounded-2xl border border-amber-200 bg-amber-50/80 p-5 text-left">
              <div className="flex gap-3">
                <svg
                  className="mt-0.5 h-5 w-5 flex-shrink-0 text-amber-600"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  />
                </svg>
                <div>
                  <p className="mb-1 text-sm font-semibold text-amber-800">
                    Volgende stap: accountactivering
                  </p>
                  <p className="text-sm leading-relaxed text-amber-700">
                    Een administrator zal uw account beoordelen en activeren. U ontvangt een
                    e-mail zodra uw account klaar is om te gebruiken.
                  </p>
                </div>
              </div>
            </div>

            <button
              type="button"
              onClick={() => nav("/login")}
              className="rounded-xl bg-rose-500 px-6 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-rose-600 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-2"
            >
              Naar inlogpagina
            </button>

            <p className="mt-4 text-xs text-slate-400">
              U kunt dit venster sluiten. We sturen u een e-mail zodra uw account is
              geactiveerd.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
